import { pipelineStory, type PipelineHighlight, type PipelineStoryInput } from '@lib/helpers/pipeline-story'
import { Badge, type BadgeTone } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'



const TONES: Readonly<Record<PipelineHighlight['tone'], BadgeTone>> = { attention: 'warning', good: 'success', neutral: 'neutral' }

/**
 * The short version (docs/pipeline-view.spec.md): a few plain sentences from
 * the numbers below, the same ones the period email and assistants open with
 * (built by `venueStoryInput`/`companyStoryInput`), and links to what they're
 * about. Nothing when there's nothing to say.
 */
export function PipelineSummary({ input }: { input: PipelineStoryInput }) {
  const story = pipelineStory(input)
  if (story.sentences.length === 0) return null
  return (
    <Card asChild>
      <section aria-labelledby="summary-heading" className="space-y-3 p-5">
        <h2 id="summary-heading" className="m-0 text-eyebrow text-ink-muted">
          The short version
        </h2>
        <p className="m-0 max-w-[60rem] text-heading font-medium text-ink">{story.sentences.join(' ')}</p>
        {story.highlights.length === 0 ? null : (
          <ul aria-label="Highlights" className="m-0 flex list-none flex-wrap gap-2 p-0">
            {story.highlights.map((h) => (
              <li key={h.text}>
                <a href={`#${h.about}`} className="rounded-sm focus-visible:focus-ds">
                  <Badge tone={TONES[h.tone]}>{h.text}</Badge>
                </a>
              </li>
            ))}
          </ul>
        )}
      </section>
    </Card>
  )
}
